import React from 'react'
import { Modal, Button, Spinner } from 'react-bootstrap'

export default function SendLinkModal({
  URL,
  showLink,
  isSending,
  invalidURL,

  handleURL,
  handleSetURL,
  handleCancel,
}) {
  return (
    <Modal show={showLink} onHide={handleCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Send a Link</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {invalidURL && <div className="alert alert-danger">Please enter a valid link. Ex: http://www.axshealthapp.com</div>}

        <input onChange={handleSetURL} value={URL} type="text" className="form-control" placeholder="Ex: https://www.axshealthapp.com" />
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={handleURL}
          disabled={isSending}
          variant="primary"
        >
          {isSending ? <Spinner size='sm' animation="border" role="status" /> : 'Send Link'}
        </Button>

        <Button disabled={isSending} variant="secondary" onClick={handleCancel}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}
